import {FC, ReactElement} from 'react'
import {Button} from '@components/ui/button'
import {AlertTriangleIcon, CheckIcon} from '@components/ui/icon'
import {Spinner} from '@components/ui/spinner'
import {useTranslation} from '@/translations/i18n.tsx'
import {ProgressBar} from '@components/ui/progress-bar'
import {cn} from '@utilities/helpers'

type UploadStepFileRow = {
    fileName: string
    progressValue?: number
    status: 'idle' | 'uploading' | 'uploaded' | 'error'
}

const statusToIcon = {
    idle: <></>,
    uploading: <Spinner size={16} />,
    uploaded: <CheckIcon size={16} />,
    error: <AlertTriangleIcon size={16} />
} as const satisfies Record<UploadStepFileRow['status'], ReactElement>

export const UploadStepFileRow: FC<UploadStepFileRow> = ({fileName, status, progressValue}) => {
    const {t} = useTranslation()
    const showProgressBar = status == 'uploading' || status == 'idle'

    const onRetry = console.log

    return (
        <div
            className={cn(
                'grid overflow-hidden items-center gap-2 px-2 border-b border-neutral-200 h-[54px]',
                showProgressBar ? 'grid-cols-[minmax(0,1fr)_160px]' : 'grid-cols-[minmax(0,1fr)_auto]'
            )}
        >
            <div className="flex items-center gap-2">
                {statusToIcon[status]}
                <p className="text-sm font-medium overflow-hidden whitespace-nowrap text-ellipsis">{fileName}</p>
            </div>
            {showProgressBar && <ProgressBar value={progressValue ?? 0} />}
            {status == 'error' && (
                <Button onClick={onRetry} variant="secondary" size="sm">
                    {t('commons:retry')}
                </Button>
            )}
        </div>
    )
}
